import { Component } from "react"
import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from 'react-bootstrap/Button';
import InputField from "../../../../views/components/InputField.Component";
import FormError from "../../../../models/FormError";
import ContactFormConfiguration from "../../models/ContactFormConfiguration";
import RszInputField from "../../../../views/components/RszInputField.Component";
import ContactFormEntry from "../../models/ContactFormEntry";

type PersonalInfoNewCustomerViewProps = {
    errors: FormError[],
    configuration: ContactFormConfiguration,
    onChange: (propertyName: string, value: string) => Promise<FormError[]>,
    initialValues: ContactFormEntry,
}

type PersonalInfoNewCustomerViewState = {
    showPicture: boolean
}

export default class PersonalInfoNewCustomerView extends Component<PersonalInfoNewCustomerViewProps, PersonalInfoNewCustomerViewState> {
    constructor(props: PersonalInfoNewCustomerViewProps) {
        super(props);

        this.state = {
            showPicture: false
        }
    }

    public togglePicture(show: boolean) {
        this.setState({
            showPicture: show
        });
    }

    render() {
        return (<>
            <Modal
                show={this.state.showPicture}
                onHide={() => this.togglePicture(false)}
                keyboard={true}
                centered={true}
            >
                <Modal.Body>
                    <img src={this.props.configuration.rszNumberFindPictureUrl} alt=""/>
                </Modal.Body>
            </Modal>
        </>);
    }
}